<template>
  <div class="w-full">
    <div class="flex flex-col md:flex-row">
      <div class="w-full">
        <div class="flex flex-1 flex-row justify-between p-5">
          <p>{{ step.description }}</p>
          <img
            alt="illustration"
            :src="step.image ? step.image.url : pharmacistBubble"
            class="w-32 object-contain hidden sm:block"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, PropType} from "vue";
import pharmacistBubble from '@/assets/images/pharmacist-bubble.png';
import {Pathway} from "@/program/interfaces/Program";

export default defineComponent({
    name: 'PathwayEnd',
    props: {
        pathway: {
            type: Object as PropType<Pathway>,
            required: true
        },
        step: {
            type: Object,
            required: true
        },
        consumerKey: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            pharmacistBubble
        };
    }
});

</script>
